import * as ng from 'angular';
import { DialogButton } from './dialogs.factory';

export class YesNoDialogComponent {
   resolve: {
      message: string;
      buttons: DialogButton[];
   };

   close: {({$value: any}): void};

   get message() {
      return this.resolve.message;
   }

   hasButton(btn: DialogButton) {
      return this.resolve.buttons.indexOf(btn) != -1;
   }

   ok(btn: DialogButton) {
      this.close({$value: btn});
   }
}

ng.module('e360').component('yesNoDialog', {
   controller: YesNoDialogComponent,
   templateUrl: require('./yesno-dialog.html'),
   bindings: {
      resolve: '<',
      close: '&'
   }
});
